import React, { useEffect, useRef } from 'react';
import { Download, ChevronDown, FileText, Receipt } from 'lucide-react';
import '../../pages/Admin/empresa/facturacion.css';

export default function FacturaPdfMenu({busy=false,onDownload}:{busy?:boolean;onDownload:(formato:'carta'|'rollo')=>void}) {
  const menu=useRef<HTMLDetailsElement>(null);
  useEffect(()=>{
    const outside=(e:MouseEvent)=>{if(menu.current&&!menu.current.contains(e.target as Node))menu.current.open=false;};
    const escape=(e:KeyboardEvent)=>{if(e.key==='Escape'&&menu.current?.open){menu.current.open=false;menu.current.querySelector('summary')?.focus();}};
    document.addEventListener('click',outside);document.addEventListener('keydown',escape);
    return()=>{document.removeEventListener('click',outside);document.removeEventListener('keydown',escape);};
  },[]);
  return <details ref={menu} className="relative inline-block">
    <summary className="fiscal-btn cursor-pointer list-none" aria-disabled={busy} onClick={e=>{if(busy)e.preventDefault();}}><Download size={16}/>{busy?'Procesando…':'Descargar PDF'}<ChevronDown size={14}/></summary>
    <div className="absolute left-0 top-full z-50 mt-2 w-52 rounded-xl border border-slate-100 bg-white p-2 shadow-xl">
      {([['carta','PDF tamaño carta',FileText],['rollo','PDF formato rollo',Receipt]] as const).map(([formato,texto,Icon])=><button key={formato} type="button" disabled={busy} className="fiscal-btn w-full !justify-start !bg-white hover:!bg-blue-50" onClick={()=>{if(menu.current)menu.current.open=false;onDownload(formato);}}><Icon size={16}/>{texto}</button>)}
    </div>
  </details>;
}
